import { parseInt } from '../utils';

export const AppConfig = JSON.parse(localStorage.getItem('appConfig'));

export const PortalUrl = localStorage.getItem('portalUrl');

export const UserToken = localStorage.getItem('userToken');

export const ClientId = localStorage.getItem('clientId');

export const ClientGuid = localStorage.getItem('clientGuid');

export const ClientDomainId = localStorage.getItem('clientDomainId');

export const UserId = parseInt(localStorage.getItem('userId'));

export const UserRoles = JSON.parse(localStorage.getItem('userRoles'));

export const CurrentLocation = parseInt(
  localStorage.getItem('currentLocation')
);

export const FiscalStartDate = localStorage.getItem('fiscalStartDate');

export const FiscalEndDate = localStorage.getItem('fiscalEndDate');

export const hasPortalFeature =
  localStorage.getItem('hasPortalFeature') === '1';
